import { popupVariant } from "@frontend/components/atoms/Menu/MenuContent.css";
import * as styles from "./ContextMenuContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { ContextMenu as BaseContextMenu } from "@base-ui/react/context-menu";
import { useMenuContext } from "@frontend/components/atoms/Menu/Menu.context";

import type { ContextMenuContentProps } from "./ContextMenu.types";
import { ContextMenuPortal } from "./ContextMenuPortal";

export function ContextMenuContent({
  className,
  children,
  side,
  align,
  sideOffset,
  alignOffset,
  ...props
}: ContextMenuContentProps): JSX.Element {
  const { variant } = useMenuContext();

  return (
    <ContextMenuPortal>
      <BaseContextMenu.Positioner
        data-slot="context-menu-positioner"
        className={styles.positioner}
        side={side}
        align={align}
        sideOffset={sideOffset}
        alignOffset={alignOffset}
      >
        <BaseContextMenu.Popup
          data-slot="context-menu-popup"
          className={clsx(styles.popup, popupVariant[variant], className)}
          {...props}
        >
          {children}
        </BaseContextMenu.Popup>
      </BaseContextMenu.Positioner>
    </ContextMenuPortal>
  );
}
